import { Link } from 'react-router';
import { Compass } from 'lucide-react';
import { FullPageState } from '@/components/StatePanel';
import { buttonVariants } from '@/components/ui/button';
import { useI18n } from '@/locales';

export function NotFoundPage() {
  const { m } = useI18n();
  return (
    <FullPageState
      icon={Compass}
      title={m.notFound.title}
      text={m.notFound.text}
      actions={
        <Link to="/" className={buttonVariants({ variant: 'primary' })}>
          {m.common.home}
        </Link>
      }
    />
  );
}
